import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import RFField from "../../../Form/RFField";
import RFForm from "../../../Form/RFForm";
import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";

const ToolbarButton = () => {
  const { editor } = useEditorContext();

  const [modal, setModal] = useState(false);
  const [btnText, setBtnText] = useState("");
  const [link, setLink] = useState("");
  const [bgcolor, setBgcolor] = useState("#dddddd");
  const [color, setColor] = useState("#000000");
  const [classNames, setClassNames] = useState("");

  const toggle = () => {
    setModal(!modal);
    setBtnText("");
    setLink("");
    setBgcolor("#dddddd");
    setColor("#000000");
    setClassNames("");
  };

  const handleSubmit = () => {
    editor
      .chain()
      .focus()
      .setButton({
        content: btnText,
        bgcolor,
        color,
        class: classNames || undefined,
      })
      .selectParentNode()
      .setLink({ href: link })
      .run();

    toggle();
  };

  return (
    <>
      <ToolbarItem
        id={`button-toolbar-item`}
        tooltip={`Gomb beszúrása`}
        active={false}
        onToggle={toggle}
        icon={<i className="fa fa-square-minus" aria-hidden="true" />}
      />

      <Modal isOpen={modal} toggle={toggle} backdrop="static">
        <RFForm onSubmit={handleSubmit}>
          <ModalHeader toggle={toggle}>Videó beszúrása</ModalHeader>
          <ModalBody>
            <RFField
              id="btn-text"
              name="btn-text"
              label="Gomb szövege"
              value={btnText}
              onChange={(e, v) => setBtnText(v)}
              required
            />
            <RFField
              id="link"
              name="link"
              label="Link"
              value={link}
              onChange={(e, v) => setLink(v)}
              required
            />
            <RFField
              id="btn-color"
              name="btn-color"
              type="color"
              label="Gomb szövegszíne"
              value={color}
              onChange={(e, v) => setColor(v)}
            />
            <RFField
              id="btn-bgcolor"
              name="btn-bgcolor"
              type="color"
              label="Gomb háttérszíne"
              value={bgcolor}
              onChange={(e, v) => setBgcolor(v)}
            />
            <RFField
              id="btn-class-names"
              name="btn-class-names"
              label="Gomb osztályneve(i)"
              value={classNames}
              onChange={(e, v) => setClassNames(v)}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary">OK</Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Mégsem
            </Button>
          </ModalFooter>
        </RFForm>
      </Modal>
    </>
  );
};

export default ToolbarButton;
